import React, { useState, useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";
import "./Formulario.css";

const Formulario = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    consulta: "",
  });

  const captcha = useRef(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onChange = () => {
    if (captcha.current.getValue()) {
      setCaptchaVerified(true);
    }
  };

  const submit = (e) => {
    e.preventDefault();

    if (captchaVerified) {
      Swal.fire({
        title: "¡Consulta enviada!",
        text: "Te responderemos a la brevedad.",
        icon: "success",
        confirmButtonColor: "#d82a20",
      }).then(() => {
        e.target.submit();
      });
    } else {
      Swal.fire({
        text: "Por favor, aceptá el captcha para enviar el formulario.",
        icon: "warning",
        confirmButtonColor: "#d82a20",
      });
    }
  };

  const isFormValid = formData.nombre && formData.email && formData.consulta;

  return (
    <Container fluid className="contact-container">
      <Row className="justify-content-right">
        <Col lg={7} sm={12} className="form-section">
          <h2 className="contact-title mt-3">Envíanos tu consulta</h2>
          <Form method="POST" action="contacto.php" onSubmit={submit}>
            <fieldset>
              <legend className="sr-only">Formulario de contacto</legend>

              <Form.Group controlId="formName">
                <Form.Control
                  type="text"
                  name="nombre"
                  placeholder="Nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="form-control"
                  aria-label="Nombre"
                />
              </Form.Group>

              <Form.Group controlId="formEmail">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-control"
                  aria-label="Email"
                />
              </Form.Group>

              <Form.Group controlId="formPhone">
                <Form.Control
                  type="tel"
                  name="telefono"
                  placeholder="Teléfono"
                  value={formData.telefono}
                  onChange={handleChange}
                  className="form-control"
                  aria-label="Teléfono"
                />
              </Form.Group>

              <Form.Group controlId="formMessage">
                <Form.Control
                  as="textarea"
                  name="consulta"
                  rows={3}
                  placeholder="Consulta"
                  value={formData.consulta}
                  onChange={handleChange}
                  required
                  className="form-control"
                  aria-label="Consulta"
                />
              </Form.Group>
            </fieldset>

            <ReCAPTCHA
              ref={captcha}
              sitekey="6LcgUvIqAAAAAHWSVPJqq0uzn7Sy_Jfathx9XTqT"
              onChange={onChange}
            />

            <Button
              variant="danger"
              type="submit"
              className="submit-button mb-0 mb-md-3 mb-lg-4"
              disabled={!isFormValid}
            >
              ENVIAR CONSULTA
            </Button>
          </Form>
        </Col>
       <Col lg={3} sm={12} className="d-none d-lg-block">
  <iframe 
    title="Ubicación Rivera Indarte"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.7402735201954!2d-58.43178502425722!3d-34.661261672933776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccb8ffc724525%3A0x9d535c062352bc99!2sRivera%20Indarte%203548%2C%20C1437BGL%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1754948640833!5m2!1ses!2sar"
    width="450"
    height="730"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</Col>
      </Row>
    </Container>
  );
};

export default Formulario;


